import React from "react";
import { Stack, TextField, Typography } from "@mui/material";

const ScaleChanger = ({ distance, onChange }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {/* <Typography variant="body1">Length:</Typography> */}
      {/* <Typography variant="body1">{distance}</Typography> */}
      <TextField
        size="small"
        label="Length"
        variant="outlined"
        value={distance}
        onChange={onChange}
        type="number"
        inputProps={{ min: 0 }}
      />
    </Stack>
  );
};

export default ScaleChanger;
